module.exports = __webpack_public_path__ + "static/media/blog3.9d5fa221.webp";